import { render, staticRenderFns } from "./ListaAlunosPorPeriodoRSituacao.vue?vue&type=template&id=6e33f85f"
import script from "./ListaAlunosPorPeriodoRSituacao.vue?vue&type=script&lang=js"
export * from "./ListaAlunosPorPeriodoRSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports